import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates'
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'
import axios from 'axios'
import { Url } from '../Url'

const ListadoJornadas = () => {
    const [jornadas, setJornadas] = useState([])
    const [productosJ, setProductosJ] = useState([])
    const [puntos, setPuntos] = useState([])
    const [punto, setPunto] = useState(0)
    const [usuarios, setUsuarios] = useState([])
    const [usuario, setUsuario] = useState(0)
    const [total, setTotal] = useState(0)
    const [totalP, setTotalP] = useState(0)
    const [totalC, setTotalC] = useState(0)
    const [totalComp, setTotalComp] = useState(0)
    const [fechaInicio, setFechaInicio] = useState('')
    const [fechaFin, setFechaFin] = useState('')
    const [medios, setMedios] = useState([])
    const [medio, setMedio] = useState(0)
    const [tab, setTab] = useState(0)
    const { setJornadaSelected, modify, setDetalleJornada } = useContext(ContextStates)
    const componentRef = useRef();

    useEffect(() => {
        const getUsuarios = async () => {
            const formData = new FormData()
            formData.append('usuariocero', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listUsrs.php',
                    method: 'POST',
                    data: formData,
                })
                setUsuarios(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getUsuarios()
    }, [])

    useEffect(() => {
        const getPuntos = async () => {
            const formData = new FormData()
            formData.append('puntocero', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listPuntos.php',
                    method: 'POST',
                    data: formData,
                })
                setPuntos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getPuntos()
    }, [])

    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof jornadas !== 'undefined') {
                jornadas.forEach(element => {
                    t = t + parseInt(element.monto)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [jornadas])

    useEffect(() => {
        const calcTotal = () => {
            let tp = 0;
            let tc = 0;
            let tcomp = 0;
            if (typeof productosJ.productos !== 'undefined') {
                productosJ.productos.forEach(element => {
                    tp = tp + parseInt(element.total)
                });
                setTotalP(tp)
            }
            if (typeof productosJ.combos !== 'undefined') {
                productosJ.combos.forEach(element => {
                    tc = tc + parseInt(element.total)
                });
                setTotalC(tc)
            }
            if (typeof productosJ.compras !== 'undefined') {
                productosJ.compras.forEach(element => {
                    tcomp = tcomp + parseInt(element.total)
                });
                setTotalComp(tcomp)
            }
        }
        calcTotal()
    }, [productosJ])

    useEffect(() => {
        const consultaJornadas = async () => {
            const formData = new FormData()
            formData.append('fechainicio', fechaInicio)
            formData.append('fechafin', fechaFin)
            formData.append('medio', medio)
            formData.append('punto', punto)
            formData.append('usuario', usuario)
            try {
                const response = await axios({
                    url: Url + 'api/listJornadas.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(response)
                setJornadas(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaJornadas()
    }, [fechaInicio, fechaFin, medio, modify, punto, usuario])

    useEffect(() => {
        const productosJornadas = async () => {
            const formData = new FormData()
            formData.append('fechainicio', fechaInicio)
            formData.append('fechafin', fechaFin)
            formData.append('medio', medio)
            formData.append('punto', punto)
            formData.append('usuario', usuario)
            try {
                const response = await axios({
                    url: Url + 'api/productosJornadas.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(response)
                setProductosJ(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        productosJornadas()
    }, [fechaInicio, fechaFin, medio, modify, punto, usuario])

    const handleView = (item) => {
        console.log(item)
        setJornadaSelected(item)
        setDetalleJornada(true)
    }


    return (
        <div className="w-full px-2" ref={componentRef}>
            <div className="w-full md:w-11/12 mx-auto bg-slate-200 mb-5 rounded-xl">
                <div className='w-full flex'>
                    <div className='w-1/2 p-3'>
                        <label htmlFor='fechainicio'>Fecha de Inicio</label>
                        <input type='date' className='w-full p-3 rounded-lg' id='fechainicio' placeholder='Fecha de Inicio' value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                    </div>
                    <div className='w-1/2 p-3 ml-5 rounded-xl'>
                        <label htmlFor='fechafin'>Fecha de Fin</label>
                        <input type='date' className='w-full p-3 rounded-lg' id='fechafin' placeholder='Fecha de Fin' value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                    </div>
                </div>
                <div className='w-full p-5 print:hidden'>
                    <select
                        className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                        id='sUsuarios'
                        value={usuario}
                        onChange={(e) => setUsuario(e.target.value)}
                    >
                        {usuarios && (
                            usuarios.map((item, index) => (
                                <option key={index} value={item.id}>{item.nombre}</option>))
                        )}
                    </select>
                </div>
                {puntos && puntos.length > 2 && (
                    <div className='w-full p-5'>
                        <select
                            className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                            id='sPunto'
                            value={punto}
                            onChange={(e) => setPunto(e.target.value)}
                        >
                            {puntos.map((item, index) => (
                                <option key={index} value={item.id}>{item.nombre}</option>))
                            }
                        </select>
                    </div>
                )}
            </div>
            <div className='w-11/12 mx-auto p-2 flex print:hidden'>
                <button
                    type='button'
                    className={`p-3 rounded uppercase ${tab === 0 ? 'bg-blue-900 text-white' : 'border border-blue-900 text-blue-900'}`}
                    onClick={() => setTab(0)}
                >Vista general</button>
                <button
                    type='button'
                    className={`p-3 ml-3 rounded uppercase ${tab === 1 ? 'bg-blue-900 text-white' : 'border border-blue-900 text-blue-900'}`}
                    onClick={() => setTab(1)}
                >Vista por productos</button>
            </div>
            {tab === 0 ? (
                <div className='w-full'>
                    {typeof jornadas !== 'undefined' && (
                        <table className='w-full mx-auto'>
                            <thead>
                                <tr className='p-1 bg-blue-400 text-white text-center'>
                                    <th>Nº</th>
                                    <th>Fecha</th>
                                    <th>Hora de apertura</th>
                                    <th>Hora de cierre</th>
                                    <th>Total</th>
                                    <th>Monto inicial</th>
                                    <th>Usuario</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    jornadas.map((item, index) => (
                                        <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                            <td>{item.numero}</td>
                                            <td>{item.fecha}</td>
                                            <td>{item.horaapertura}</td>
                                            <td>{item.horacierre}</td>
                                            <td>$ {item.monto}</td>
                                            <td>$ {item.montoinicial}</td>
                                            <td>{`${item.apellido}, ${item.nombre}`}</td>
                                            <td className='text-center'>
                                                <button className='bg-blue-600 hover:bg-blue-400 rounded-lg py-1 px-3 text-white' onClick={() => handleView(item)}>Ver</button>
                                            </td>
                                        </tr>
                                    ))
                                }
                                <tr className='border border-gray-300 p-2 text-center font-bold bg-slate-50'>
                                    <td>Total</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>${total}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </div>
            ) : (
                <div className='w-full'>
                    <h2 className='uppercase text-3xl text-center mb-5 text-gray-600 bg-green-300 p-3 rounded-lg w-full'>Ingresos</h2>
                    <h3 className='text-center text-2xl font-bold text-gray-600 uppercase mb-2'>Productos en general</h3>
                    {typeof productosJ.productos !== 'undefined' && (
                        <table className='w-full mx-auto'>
                            <thead>
                                <tr className='p-1 bg-blue-400 text-white text-center uppercase'>
                                    <th>Producto</th>
                                    <th>Cantidad</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    productosJ.productos.map((item, index) => (
                                        <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                            <td>{item.descripcion}</td>
                                            <td>{item.cantidad}</td>
                                            <td>$ {parseFloat(item.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        </tr>
                                    ))
                                }
                                <tr className='border border-gray-300 p-2 text-center font-bold bg-slate-50'>
                                    <td>Total</td>
                                    <td></td>
                                    <td>${totalP.toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    {typeof productosJ.combos !== 'undefined' && (
                        <div className='w-full mt-5'>
                            <h3 className='text-center text-2xl font-bold text-gray-600 uppercase mb-2'>Unidades de productos compuestos</h3>
                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center uppercase'>
                                        <th>Producto unitario</th>
                                        <th>Producto central</th>
                                        <th>Cantidad</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        productosJ.combos.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.descripcion}</td>
                                                <td>{item.productocentral}</td>
                                                <td>{item.cantidad}</td>
                                                <td>$ {parseFloat(item.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                            </tr>
                                        ))
                                    }
                                    <tr className='border border-gray-300 p-2 text-center font-bold bg-slate-50'>
                                        <td>Total</td>
                                        <td></td>
                                        <td></td>
                                        <td>${totalC.toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                    <h2 className='uppercase text-3xl text-center mt-10 mb-5 text-gray-600 bg-orange-300 p-3 rounded-lg w-full'>Egresos</h2>
                    {typeof productosJ.compras !== 'undefined' && (
                        <div className='w-full mt-5'>
                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center uppercase'>
                                        <th>Producto unitario</th>
                                        <th>Cantidad</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        productosJ.compras.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.descripcion}</td>
                                                <td>{item.cantidad}</td>
                                                <td>$ {parseFloat(item.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                            </tr>
                                        ))
                                    }
                                    <tr className='border border-gray-300 p-2 text-center font-bold bg-slate-50'>
                                        <td>Total</td>
                                        <td></td>
                                        <td>${totalComp.toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
            <ReactToPrint
                trigger={() =>
                    <p
                        className="print:hidden w-1/3 sm:w-1/4 flex shadow-md p-3 mt-10 ml-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg hover:cursor-pointer"
                    >
                        <FaPrint className='mx-auto mt-1' />
                        <span className='mx-auto text-center'>
                            Imprimir Listado
                        </span>
                    </p>}
                content={() => componentRef.current}
            />
        </div>
    )
}

export default ListadoJornadas